var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrainFilled = function SvgTrainFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0A4.5 4.5 0 0 1 22 4.5v12c0 2.208-1.65 4.11-3.802 4.448l2.157 2.157c.328.328.093.895-.413.895h-1.819c-.398 0-.782-.16-1.064-.44L14.5 21h-6l-2.56 2.56c-.282.28-.664.44-1.061.44H3.018a.525.525 0 0 1-.372-.895l2.157-2.157C2.65 20.611 1 18.708 1 16.5v-12A4.5 4.5 0 0 1 5.5 0h12ZM4 10.5c0 .83.672 1.5 1.5 1.5h3.75c.83 0 1.5-.67 1.5-1.5V6c0-.83-.67-1.5-1.5-1.5H5.5A1.5 1.5 0 0 0 4 6v4.5Zm9.75-6c-.83 0-1.5.67-1.5 1.5v4.5c0 .83.67 1.5 1.5 1.5h3.75c.83 0 1.5-.67 1.5-1.5V6c0-.83-.67-1.5-1.5-1.5h-3.75ZM5.5 15a1.5 1.5 0 1 0-.001 2.999A1.5 1.5 0 0 0 5.5 15Zm12 3c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5Z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgTrainFilled;